import { useEffect } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { posPath } from "@/utilities/routePaths"
import { apiFetch } from "@/hooks/apiFetch"
import { useAppDispatch } from "@/lib/hooks"
import { User } from "@/redux/model"
import { setUser } from "@/redux/slices/authSlice"
import { ApiResponse } from "@/types/commonTypes"

const AuthRoutes = () => {
  const user = localStorage.getItem("user")
  const dispatch = useAppDispatch()

  useEffect(() => {
    const refreshProfile = () => {
      if (!localStorage.getItem("token")) {
        return
      }

      void apiFetch<ApiResponse<User>>("profile")
        .then((response) => {
          if (response) {
            dispatch(setUser(response.data))
          }
        })
        .catch(() => {})
    }

    refreshProfile()
    window.addEventListener("focus", refreshProfile)

    return () => window.removeEventListener("focus", refreshProfile)
  }, [dispatch])

  return user ? <Outlet /> : <Navigate to={posPath("login")} replace />
}

export default AuthRoutes
